import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';
import DurationConstructor = moment.unitOfTime.DurationConstructor;

export interface FromNowPipeOptions {
  amount?: number;
  unit?: DurationConstructor;
  withoutPrefix?: boolean;
}

@Pipe({
  name: 'fromNow',
})
export class FromNowPipe implements PipeTransform {
  transform(
    value: string | moment.Moment,
    options: FromNowPipeOptions = { amount: 0, unit: 'days', withoutPrefix: false },
  ): string {
    if (!value) {
      return '';
    }

    return moment(value).add(options.amount, options.unit).fromNow(options.withoutPrefix);
  }
}
